export default __webpack_public_path__ + "static/media/icon-eye.368770e0.svg";